import React, { forwardRef } from 'react';

type ScrollableFeedProps = {
  children?: React.ReactNode;
  className?: string;
  loading?: boolean;
};

const ScrollableFeed = forwardRef<HTMLDivElement, ScrollableFeedProps>(
  ({ children, className }, ref) => {
    return (
      <div ref={ref} className={`scrollable-feed overflow-y-auto ${className}`}>
        {children}
      </div>
    );
  },
);

export default ScrollableFeed;
